import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { formDesignProps } from '../../form_fields/ctrl_proptype';
import { toHex } from '../../../shared/form-lib';

const getAlignmentId = (alignment) => {
  switch (alignment) {
    case 'left floated':
      return 'left';
    case 'right floated':
      return 'right';
    case 'rtl':
      return 'rtl';
    case 'ltr':
      return 'ltr';
    default:
      return 'centered';
  }
};

const FormHeader = ({ formDesign, formName, inIntro }) => {
  const headerStyles = {
    '--header-padding': `${formDesign.design.header_padding}px ${formDesign.design.header_padding}px ${
      formDesign.design.header_padding / 2
    }px`,
    '--header-background': toHex(formDesign.design.header_background_color),
    '--header-color': toHex(formDesign.design.header_color),
    '--header-align': formDesign.design.header_alignment,
    '--header-size': formDesign.old.form_title_font_size,
    '--font-family': formDesign.old.form_font,
  };

  const isLogoHere = formDesign.old.custom_logo_image && formDesign.design.logo_placement === 'header';
  const alignmentId = isLogoHere ? getAlignmentId(formDesign.old.custom_logo_alignment) : '';
  const underlineTitle = formDesign.old.underline_title;
  const customLogo = formDesign.old.custom_logo_image;

  return (
    <Wrapper underlineTitle={underlineTitle} style={headerStyles} inIntro={inIntro}>
      <header id={alignmentId}>
        {isLogoHere && (
          <Logo id={alignmentId}>
            <div>
              <img src={customLogo} alt="Custom Logo" />
            </div>
          </Logo>
        )}

        <h1 className="title">{formName}</h1>
      </header>
    </Wrapper>
  );
};

FormHeader.propTypes = {
  formDesign: PropTypes.shape(formDesignProps).isRequired,
  formName: PropTypes.string.isRequired,
  inIntro: PropTypes.bool,
};

export default FormHeader;

const Wrapper = styled.div`
  background: var(--header-background);
  padding: var(--header-padding);
  direction: initial;

  ${({ inIntro }) =>
    inIntro &&
    `
    padding: 50px 0 0 0;
    background: transparent;
  `};

  header {
    ${tw`flex w-full flex-col gap-3.5`};
    text-align: var(--header-align);

    &#rtl {
      ${tw`items-center justify-start flex-row-reverse gap-5`};
    }

    &#ltr {
      ${tw`items-center justify-start flex-row gap-5`};
    }
  }

  .title {
    ${tw`font-bold w-full my-0 mx-auto`};
    color: ${({ inIntro }) => (inIntro ? 'var(--formTextColor, #000000)' : `var(--header-color)`)} !important;
    font-family: var(--font-family) !important;
    font-size: var(--header-size);
    word-break: break-word;
    font-weight: 500;

    ${({ underlineTitle }) =>
      underlineTitle &&
      `
      border-bottom: 0.5px solid var(--formTextColor, rgba(34,36,38,.15));
    `};

    @media screen and (min-width: 769px) {
      width: ${({ inIntro }) => (inIntro ? '65%' : '100%')};
    }
  }
`;

const Logo = styled.div`
  ${tw`flex`};

  &#left {
    ${tw`justify-start`};
  }

  &#right {
    ${tw`justify-end`};
  }

  &#centered {
    ${tw`justify-center`};
  }

  img {
    ${tw`relative block max-w-full bg-transparent max-h-24`};
  }
`;
